module.exports = __webpack_public_path__ + "static/media/segmentation.6ba16edf.png";